import { State2Way } from "@/decorators";
import moment from "moment-timezone";
import axios from "axios";
import fileDownload from "js-file-download";

import { getCommonDocumentWhere } from "../../services/graphqlServices";

import MAX_AMOUNT_DOCUMENT from "../../graphql/document/MaxDocumentPrice.gql";
import DELETE_DOCUMENTS from "../../graphql/document/DeleteDocuments.gql";
import UPDATE_THIRDPARTY_COMPANY_DOCUMENTS from "../../graphql/document/UpdateManyDocuments.gql";
import AUDIT_ITEMS from "../../graphql/audit/AuditDocumentItems.gql";
import UNTAGGED_DOCUMENTS from "../../graphql/document/UntaggedDocuments.gql";
import DOCUMENTS_ID_IN from "../../graphql/document/FilterDocumentsIdIn.gql";

import { Apollo } from "@/decorators";
import { Document } from "../../../../types";
import { createCompany } from "../../services/companyServices";
import { getDocumentTitle, isDeletionDisabled } from "../../services/documentServices";

import { DocumentTableBase } from "./DocumentTableBase";
import { AuditCheckDocumentName } from "./enum/AuditCheckDocumentName.enum";

import getEnv from "../../env";
import { getChatStatus } from "../../services/chatServices";
import { Component, Watch } from "vue-facing-decorator";

const env = getEnv();

export type SortByListItem = { text: string; value: string; descending: boolean; key: string };

@Component
export class Documents extends DocumentTableBase {
    importDocument = false;
    miscellaneousOperationDialog = false;

    showMoreFilters = false;

    documentTypeToUpload: string = "";

    dialogChooseDownload = false;
    // docToDownload = null;

    activeSaleInvoices = false;

    activeExpenseReport = false;

    showRangePicker = false;

    documentStateUpdateSub: any = null;

    firstRequestDone = false;

    freeTagFocused = false;

    stripeDialog = false;

    selectedDocumentIds = [];

    dialogDeleteSelectedDocument = false;

    dialogDeletePermanentlySelectedDocument = false;

    amountSum = 0;

    newThirdPartyCompany = {
        id: "",
    };

    count = 0;

    uploadDocumentsFromMailDialog: boolean = false;

    onlyAccounting = false;

    auditChecks = [
        { value: "", text: "Pas de contrôle" },
        { value: AuditCheckDocumentName.CheckDocumentDoublon, text: "Doublon" },
        { value: AuditCheckDocumentName.CheckDocumentNotBalanced, text: "Non équilibré" },
        {
            value: AuditCheckDocumentName.CheckDocumentOutsideActiveAccountingPeriods,
            text: "Documents hors exercices",
        },
        { value: AuditCheckDocumentName.CheckDocumentNoDate, text: "Documents sans date" },
    ];

    showIgnoredAuditChecks = false;

    query = null;

    get activateTagguing() {
        return true;
    }

    get allTypes() {
        return [];
    }

    get showTotal() {
        if (this.$vuetify.display.mobile) return false;
        if (!this.pagination.totalItems) return false;
        if (this.documentType === "MAIL") return false;
        if (this.documentType === "UNKNOWN") return false;
        if (this.documentType === "MISCELLANEOUS") return false;
        if (this.documentType === "BANK_STATEMENT") return false;

        return true;
    }

    get isAllSelected() {
        return this.documents.length && this.selectedDocumentIds.length === this.documents.length;
    }

    set isAllSelected(value) {
        if (value) {
            this.selectedDocumentIds = this.documents.map((d) => d.id);
        } else {
            this.selectedDocumentIds = [];
        }
    }

    set sortBy(data) {
        this.pagination.sortBy = [data.value];
        this.pagination.descending = [data.descending];
    }

    get sortBy() {
        if (this.pagination && this.pagination.sortBy && this.pagination.sortBy.length) {
            const key = this.pagination.descending[0]
                ? this.pagination.sortBy[0] + "_desc"
                : this.pagination.sortBy[0] + "_asc";
            const head = this.sortByList.find((x) => x.key === key);
            if (head) {
                return {
                    key: key,
                    value: this.pagination.sortBy[0],
                    descending: this.pagination.descending[0],
                    text: head.text,
                };
            }
        }
        return null;
    }

    set sortByMail(data) {
        this.pagination.sortByMail = [data.value];
        this.pagination.descending = [data.descending];
    }

    get sortByMail() {
        if (this.pagination && this.pagination.sortByMail && this.pagination.sortByMail.length) {
            const key = this.pagination.descending[0]
                ? this.pagination.sortByMail[0] + "_desc"
                : this.pagination.sortByMail[0] + "_asc";
            const head = this.sortByListMail.find((x) => x.key === key);
            if (head) {
                return {
                    key: key,
                    value: this.pagination.sortByMail[0],
                    descending: this.pagination.descending[0],
                    text: head.text,
                };
            }
        }
        return null;
    }

    get sortByListMail(): SortByListItem[] {
        const result = this.mailHeaders
            .filter((x) => x.sortable)
            .flatMap((x) => {
                const list = [];
                list.push({
                    text: x.text + " croissant",
                    value: x.value,
                    descending: false,
                    key: x.value + "_asc",
                });
                list.push({
                    text: x.text + " décroissant",
                    value: x.value,
                    descending: true,
                    key: x.value + "_desc",
                });

                return list;
            });

        return result;
    }

    get sortByList(): SortByListItem[] {
        const result = this.headers
            .filter((x) => x.sortable)
            .flatMap((x) => {
                const list = [];
                if (x.onlyDesc) {
                    list.push({
                        text: x.text,
                        value: x.value,
                        descending: true,
                        key: x.value + "_desc",
                    });
                } else {
                    list.push({
                        text: x.text + " croissant",
                        value: x.value,
                        descending: false,
                        key: x.value + "_asc",
                    });
                    list.push({
                        text: x.text + " décroissant",
                        value: x.value,
                        descending: true,
                        key: x.value + "_desc",
                    });
                }
                return list;
            });
        // debugger
        return result;
    }

    get filter() {
        const filter = this.$store.state.documentFilter;
        if (
            (this.minAmount && parseFloat(this.minAmount) > this.minDocumentAmount) ||
            (this.maxAmount && parseFloat(this.maxAmount) < this.maxDocumentAmount)
        ) {
            this.filterByPrice = true;
        } else {
            this.filterByPrice = false;
        }
        return filter;
    }

    admins = [
        ["Management", "mdi-account-multiple-outline"],
        ["Settings", "mdi-cog-outline"],
    ];

    accountingItemEditionTitle = "";

    onFreeTagFocus() {
        this.freeTagFocused = true;
    }

    onFreeTagBlur() {
        setTimeout(() => {
            this.freeTagFocused = false;
        }, 500);
    }

    openDocumentWizard() {
        this.documentTypeToUpload = "";
        this.importDocument = true;
    }

    openLoanPage() {
        if (this.selectedCompany.id) {
            this.$router.push({
                name: "loan",
                params: {
                    companyId: this.selectedCompany.id,
                },
            });
        }
    }

    openLeasingPage() {
        if (this.selectedCompany.id) {
            this.$router.push({
                name: "leasing",
                params: {
                    companyId: this.selectedCompany.id,
                },
            });
        }
    }

    /**
     * Open the document wizard to upload a document type
     * @param documentType
     */
    startUpload(documentType) {
        this.documentTypeToUpload = documentType;
        this.importDocument = true;
    }

    dialogChangeThirdPartyCompanyDocument = false;

    get onlyPurchasesSelected() {
        if (!this.selectedDocumentIds.length) {
            return false;
        }
        return (
            this.documents.filter(
                (x) =>
                    !!x && this.selectedDocumentIds.includes(x.id) && x.type === "PURCHASE_INVOICE",
            ).length === this.selectedDocumentIds.length
        );
    }

    get onlySalesSelected() {
        if (!this.selectedDocumentIds?.length) {
            return false;
        }
        return (
            this.documents.filter(
                (x) => !!x && this.selectedDocumentIds.includes(x.id) && x.type === "SALES_INVOICE",
            ).length === this.selectedDocumentIds.length
        );
    }

    get selectedDocuments() {
        return this.documents.filter((x) => !!x && this.selectedDocumentIds.includes(x.id));
    }

    get nextPageDisabled() {
        return (
            Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage) <=
            this.pagination.page
        );
    }

    subTitle(document) {
        if (this.$vuetify.display.mobile) {
            const subTitle = document.invoiceNumber ? "N° " + document.invoiceNumber : "";
            return subTitle;
        }
        const subTitle = document.invoiceNumber ? "Numéro: " + document.invoiceNumber : "";
        return subTitle;
    }

    formatType(type) {
        return this.$t("document.type." + type);
    }

    formatStatus(status) {
        return this.$t("document.status." + status);
    }

    isFiltered(x: any, y: any): boolean {
        const optFields = ["showFilterBox", "totalItems"];
        if (x && y && typeof x === "object" && typeof y === "object") {
            return (
                Object.keys(x).length === Object.keys(y).length &&
                Object.keys(x).reduce((isEqual, key) => {
                    if (optFields.includes(key)) {
                        return isEqual;
                    }
                    return isEqual && this.isFiltered(x[key], y[key]);
                }, true)
            );
        }
        return x === y;
    }

    formatReconciliation(status) {
        if (status === "VALIDATED") return "Rapproché";
        if (status === "INVALIDATED") return "Refusé";
        return "Non rapproché";
    }

    reconciliationColor(document) {
        if (document.status === "INFORMATION_REQUEST") {
            return "primary";
        }
        if (
            document.reconciliationStatus.allStatus.PENDING_VALIDATION ||
            document.reconciliationStatus.allStatus.PENDING_VALIDATION_FROM_CLIENT
        ) {
            return "magic";
        }
        if (Math.abs(document.reconciliationStatus.toReconciliateAmountSigned) < 1e-2) {
            return "grey";
        }
        if (Math.abs(document.reconciliationStatus.notReconciliatedAmountSigned) < 1e-2) {
            return "green"; // return "secondary";
        }
        if (Math.abs(document.reconciliationStatus.reconciliatedAmountSigned) < 1e-2) {
            return "red";
        }
        // const type = document.type
        // const reconciliationStatus = document.reconciliationStatus
        // if (reconciliationStatus && reconciliationStatus.allStatus) {
        //     if (reconciliationStatus.allStatus) {
        //         if (reconciliationStatus.allStatus.EDITION) {
        //             return "orange";
        //         }
        //         if (reconciliationStatus.allStatus.RECONCILIATION_DONE) {
        //             return "secondary";
        //         }
        //         if (reconciliationStatus.allStatus.PENDING_VALIDATION) {
        //             return "magic";
        //         }
        //         if (reconciliationStatus.allStatus.VALIDATED) {
        //             return "secondary";
        //         }
        //     }
        // }
        return "orange";
    }

    reconciliationIcon(document) {
        if (document.status === "DENIED") {
            return "";
        }
        if (document.status === "DELETED") {
            return "";
        }
        if (document.status === "PENDING") {
            return "";
        }
        if (document.status === "INFORMATION_REQUEST") {
            return "$fa-comments";
        }
        if (document.type === "BANK_STATEMENT" || document.type === "MISCELLANEOUS") {
            return "";
        }
        if (
            document.reconciliationStatus?.allStatus?.PENDING_VALIDATION ||
            document.reconciliationStatus?.allStatus?.PENDING_VALIDATION_FROM_CLIENT
        ) {
            return "$fa-magic";
        }
        if (Math.abs(document.reconciliationStatus?.toReconciliateAmountSigned) < 1e-2) {
            // return "$oss-circle-check"
            return "$fa-check-circle";
        }
        if (Math.abs(document.reconciliationStatus?.notReconciliatedAmountSigned) < 1e-2) {
            // return "$oss-circle-check"
            return "$fa-check-circle";
        }
        if (Math.abs(document.reconciliationStatus?.reconciliatedAmountSigned) < 1e-2) {
            return "$oss-circle-uncheck";
        }

        return "$oss-adjust";
        // const reconciliationStatus = document.reconciliationStatus
        // if (reconciliationStatus && reconciliationStatus.allStatus) {
        //     if (reconciliationStatus.allStatus) {
        //         if (reconciliationStatus.allStatus.EDITION) {
        //             return "$oss-adjust";
        //         }
        //         if (reconciliationStatus.allStatus.RECONCILIATION_DONE) {
        //             return "$oss-circle-check";
        //         }
        //         if (reconciliationStatus.allStatus.PENDING_VALIDATION) {
        //             return "$fa-magic";
        //         }
        //         if (reconciliationStatus.allStatus.VALIDATED) {
        //             // return "$oss-circle-check";
        //             return "$fa-check-circle"
        //         }
        //     }
        // }
        // return "$oss-circle-uncheck"
    }

    reconciliationTooltip(document) {
        if (document.status === "INFORMATION_REQUEST") {
            return "Demande d'information";
        }
        if (document.status === "DENIED") {
            return "";
        }
        if (document.status === "DELETED") {
            return "";
        }
        if (document.status === "PENDING") {
            return "";
        }
        if (
            document.reconciliationStatus?.allStatus.PENDING_VALIDATION ||
            document.reconciliationStatus?.allStatus.PENDING_VALIDATION_FROM_CLIENT
        ) {
            return "Lettrage à valider";
        }
        if (Math.abs(document.reconciliationStatus?.toReconciliateAmountSigned) < 1e-2) {
            return "Aucun lettrage nécessaire";
        }
        if (Math.abs(document.reconciliationStatus?.notReconciliatedAmountSigned) < 1e-2) {
            return "Lettré";
        }
        if (Math.abs(document.reconciliationStatus?.reconciliatedAmountSigned) < 1e-2) {
            return "Lettrage à commencer";
        }

        return "Lettrage à terminer";
    }

    statusColor(document) {
        const status = document.status;
        switch (status) {
            case "PENDING":
            case "DENIED":
            case "DELETED":
            case "ERROR":
                return "error";
            case "INFORMATION_REQUEST":
                return "primary";
            case "ORIGINAL_UPLOADED":
                return "orange";
            case "UPLOADED":
                return "orange";
            case "ANALYSED":
            case "ANALYSED_OK":
                return "secondary";
            case "VALIDATED":
                return "green";
            default:
                return "error";
        }
    }

    statusTooltip(item) {
        const status = item.status;
        if (status === "INFORMATION_REQUEST") return item.chatStatus;
        return this.$t("document.status." + status);
    }

    declaredDateTooltip(item) {
        const vatDeclaration = item.vatDeclaration;
        const date = vatDeclaration?.createdAt;
        if (date) {
            const momentDate: string = moment(date).format("DD/MM/YYYY");
            return `le ${momentDate}`;
        }
        return "";
    }

    mailFrom(data) {
        const sender = data.split("<")[0];
        return sender.replace(/"/g, "");
    }

    mailTo(data) {
        const receivers = data.split(",");
        if (receivers.length === 1) {
            return this.mailFrom(receivers[0]);
        } else if (receivers.length === 2) {
            return this.mailFrom(receivers[0]) + ", " + this.mailFrom(receivers[1]);
        } else {
            return (
                this.mailFrom(receivers[0]) +
                ", " +
                this.mailFrom(receivers[1]) +
                " (+" +
                (receivers.length - 2) +
                " autres)"
            );
        }
    }

    stateColor(item) {
        const reconciliationStatus = item.reconciliationStatus;
        const status = item.status;
        let color = "";

        switch (status) {
            case "INFORMATION_REQUEST":
                // color = "yellow_custom";
                return item.statusChatColor;
                break;
            case "ANALYSED":
            case "ANALYSED_OK":
                color = "primary";
                break;
            case "UPLOADED":
                color = "yellow_custom";
                break;
            case "ORIGINAL_UPLOADED":
                color = "yellow_custom";
                break;
            case "VALIDATED":
                color = "secondary";
                if (reconciliationStatus) {
                    if (reconciliationStatus.allStatus) {
                        if (reconciliationStatus.allStatus.EDITION) {
                            return "yellow_custom";
                        }
                        if (reconciliationStatus.allStatus.RECONCILIATION_DONE) {
                            return "yellow_custom";
                        }
                        if (reconciliationStatus.allStatus.PENDING_VALIDATION) {
                            return "yellow_custom";
                        }
                        if (reconciliationStatus.allStatus.VALIDATED) {
                            return "secondary";
                        }
                    } else if (reconciliationStatus.status) {
                        if (reconciliationStatus.status === "EDITION") {
                            return "yellow_custom";
                        }
                        if (reconciliationStatus.status === "RECONCILIATION_DONE") {
                            return "yellow_custom";
                        }
                        if (reconciliationStatus.status === "PENDING_VALIDATION") {
                            return "yellow_custom";
                        }
                        if (reconciliationStatus.status === "VALIDATED") {
                            return "secondary";
                        }
                    }
                }
                break;
            case "RECONCILED":
                color = "error";
                break;
            case "DENIED":
            case "DELETED":
                color = "error";
                break;
            default:
                break;
        }
        return color;
    }

    // documentColor(document) {
    //     if (!document.grossAmountSigned) {
    //         if (getPurchaseTypes().indexOf(document.type) !== -1) return "red_custom";
    //         if (getSalesTypes().indexOf(document.type) !== -1) return "secondary";
    //         if (document.type === "PAY_SLIP") return "red_custom";
    //         return "grey";
    //     }
    //     if (!document.grossAmountSigned) return "grey";
    //     if (document.grossAmountSigned < 0) return "red_custom";
    //     return "secondary";
    // }

    refetchDocuments() {
        this.importDocument = false;

        if (this.auditCheck) {
            if (this.$apollo.queries.auditCheckDocumentItems) {
                this.$apollo.queries.auditCheckDocumentItems.refetch();
            }
        } else if (this.partitionTagId) {
            if (this.$apollo.queries.partitionTagDocuments) {
                this.$apollo.queries.partitionTagDocuments.refetch();
            }
        } else {
            if (this.$apollo.queries.dbDocuments) {
                this.$apollo.queries.dbDocuments.refetch();
            }
        }
    }

    @State2Way("updateDocumentPagination", "documentFilter.pagination")
    pagination!: any;

    @State2Way("updateDocumentSearch", "documentFilter.search")
    search!: string;

    @State2Way("updateDocumentBeginDate", "documentFilter.date.begin")
    beginDate!: string;

    @State2Way("updateDocumentEndDate", "documentFilter.date.end")
    endDate!: string;

    @State2Way("updateDocumentMaxAmount", "documentFilter.amount.maximum")
    maxAmount!: string;

    @State2Way("updateDocumentMinAmount", "documentFilter.amount.minimum")
    minAmount!: string;

    @State2Way("updateDocumentFilterByPrice", "documentFilter.filterByPrice")
    filterByPrice!: boolean;

    @State2Way("updateDocumentThirdPartyCompanyName", "documentFilter.thirdPartyCompanyName")
    thirdPartyCompanyName!: string;

    @State2Way("updateDocumentType", "documentFilter.type")
    documentType!: string;

    @State2Way("updateDocumentAllTypes", "documentFilter.allTypes")
    allDocumentTypes!: string[];

    @State2Way("updateDocumentStatus", "documentFilter.status")
    documentStatus!: string;

    @State2Way("updateDocumentDeclaredStatus", "documentFilter.declaredStatus")
    declaredStatus!: string;

    @State2Way("updateDocumentTags", "documentFilter.tags")
    documentTags!: any[];

    @State2Way("updateDocumentPrevNext", "documentFilter.prevNext")
    prevNext!: any;

    @State2Way("updateDocumentAuditCheck", "documentFilter.auditCheck")
    auditCheck!: string;

    @State2Way("updateDocumentPartitionTagId", "documentFilter.partitionTagId")
    partitionTagId!: string;

    @State2Way("updateAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    selectedAccountingPeriod!: any;

    get selectedAccountingClosing() {
        return this.$store.state.accountingPeriod?.selectedAccountingClosing?.id
            ? this.$store.state.accountingPeriod.selectedAccountingClosing
            : null;
    }

    get type() {
        let type = this.documentType;
        for (const tag of this.documentTags) {
            if (tag.primaryLog === type) {
                type += "#" + tag.id;
                break;
            }
        }
        return type;
    }

    set type(type) {
        if (!type.startsWith("BANK_TRANSACTION")) {
            const values = type.split("#");
            if (values.length === 2) {
                this.documentType = values[0];
                const tagId = values[1];
                const tag = this.allCompanyTags.find((t) => t.id === tagId);
                if (tag) {
                    this.documentTags = [tag];
                } else {
                    this.documentTags = [{ id: tagId }];
                }
            } else {
                this.documentType = type;
                for (let i = this.documentTags.length - 1; i >= 0; i--) {
                    const tag = this.documentTags[i];
                    if (tag.primaryLog && tag.primaryLog !== type) {
                        this.documentTags.splice(i, 1);
                    }
                }
            }
        } else {
            this.documentType = type;
        }
    }

    @Watch("search")
    @Watch("minAmount")
    @Watch("maxAmount")
    @Watch("beginDate")
    @Watch("endDate")
    @Watch("documentType")
    @Watch("documentTags", { deep: true })
    @Watch("documentStatus")
    @Watch("declaredStatus")
    @Watch("thirdPartyCompanyName")
    @Watch("auditCheck")
    @Watch("partitionTagId")
    onFilterChanged() {
        this.pagination.page = 1;
        this.dbDocuments = [];
        this.auditCheckDocumentItems = [];
        this.partitionTagDocuments = [];
        this.partitionTagDocumentIds = [];
        this.firstRequestDone = false;
        this.selectedDocumentIds = [];
    }

    @Watch("auditCheck")
    onAuditCheckChanged(value) {
        this.clearAllFilters();
        this.auditCheck = value;
    }

    @Watch("partitionTagId")
    onPartitionTagIdChanged(value) {
        this.clearAllFilters();
        this.partitionTagId = value;
    }

    @Watch("selectedAccountingPeriod")
    onAccountingPeriodChanged(value, prevValue) {
        if (value) {
            if (!this.beginDate) {
                this.beginDate = moment(value.start).format("YYYY-MM-DD");
            } else {
                const mBegin = moment(this.beginDate);
                if (mBegin.isBefore(moment(value.start)) || mBegin.isAfter(moment(value.end))) {
                    this.beginDate = moment(value.start).format("YYYY-MM-DD");
                }
            }
            if (!this.endDate) {
                this.endDate = moment(value.end).format("YYYY-MM-DD");
            } else {
                const mEnd = moment(this.endDate);
                if (mEnd.isAfter(moment(value.end)) || mEnd.isBefore(moment(value.start))) {
                    this.endDate = moment(value.end).format("YYYY-MM-DD");
                }
            }
        }
    }

    mailHeaders = [
        {
            text: "Date",
            value: "date",
            sortable: true,
            align: "center",
            width: undefined,
        },
        {
            text: "Destinataire",
            value: "to",
            sortable: true,
            align: "center",
            width: undefined,
        },
        {
            text: "Emetteur",
            value: "from",
            sortable: true,
            align: "center",
            width: undefined,
        },
        {
            text: "Autre société",
            value: "otherCompany",
            sortable: true,
            align: "center",
            width: undefined,
        },
        {
            text: "Sujet",
            value: "subject",
            sortable: true,
            align: "center",
            width: undefined,
        },

        // {
        //     text: "Dernière modification",
        //     value: "updatedAt",
        //     sortable: true,
        //     align: "center",
        //     width: undefined
        // }
    ];

    get headers() {
        const headers = [];
        if (this.isAccountingUser) {
            headers.push({
                text: "",
                value: "",
                sortable: false,
                align: "center",
                width: undefined,
            });
        }
        headers.push({
            text: "Type",
            value: "",
            sortable: false,
            align: "center",
            width: undefined,
        });
        headers.push({
            text: "Fournisseur/Client/Description",
            value: "thirdPartyCompany.name",
            sortable: false,
            align: "center",
            width: undefined,
        });
        headers.push({
            text: "N° Facture",
            value: "invoiceNumber",
            sortable: true,
            align: "center",
            width: undefined,
        });
        headers.push({
            text: "Date",
            value: "date",
            sortable: true,
            align: "center",
            width: undefined,
        });
        headers.push({
            text: "Montant TTC",
            value: "grossAmountSigned",
            sortable: true,
            align: "center",
            width: undefined,
        });

        headers.push({
            text: "Dernière modification",
            value: "updatedAt",
            sortable: true,
            onlyDesc: true,
            align: "center",
            width: undefined,
        });
        headers.push({
            text: "Date création",
            value: "createdAt",
            sortable: true,
            onlyDesc: true,
            align: "center",
            width: undefined,
        });

        if (
            this.currentUser.profile.configuration.document.statusDisplay ||
            this.selectedCompany.solution === "MANAGEMENT"
        ) {
            // headers.push({
            //     text: "CC",
            //     value: "",
            //     sortable: false,
            //     align: "center",
            //     width: undefined
            // });
            headers.push({
                text: "Statut",
                value: "",
                sortable: false,
                align: "center",
                width: undefined,
            });
            headers.push({
                text: "File",
                value: "",
                sortable: false,
                align: "center",
                width: undefined,
            });
        }
        // if (this.selectedCompany.solution !== "MANAGEMENT") {
        //     headers.push({
        //         text: "",
        //         value: "",
        //         sortable: false,
        //         align: "center",
        //         width: undefined
        //     });
        // }

        return headers;
    }

    // async deleteDocument(id) {
    //     await this.$apollo.mutate({
    //         mutation: gql`
    //             mutation deleteDocuments($ids: [ID!]){
    //                 deleteDocuments(data: {
    //                     ids: $ids
    //                 }){
    //                     notDeleted
    //                 }
    //             }
    //         `,
    //         variables: {
    //             ids: [id]
    //         }
    //     })
    // }

    //   @Apollo(
    //       {
    //           query: LIST_COMPANY_PROVIDERS,
    //           variables() {
    //               return {
    //                   companyId: this.selectedCompany.id
    //               };
    //           }
    //       },
    //       data => (data ? data.companies : [])
    //   )
    //   providers: Company[] = [];

    @Apollo({
        query: MAX_AMOUNT_DOCUMENT,
        variables() {
            return {
                companyId: this.selectedCompany.id,
                where: getCommonDocumentWhere(
                    this.selectedCompany.id,
                    this.selectedAccountingClosing,
                    this.filter,
                    this.onlyAccounting,
                    true,
                ),
            };
        },
        skip() {
            return (
                !this.selectedCompany ||
                !this.selectedCompany.id ||
                this.filter.type === "MAIL" ||
                this.filter.type.startsWith("BANK_TRANSACTION") ||
                this.filter.status === "RECONCILIATION_MISSING" ||
                this.filter.status === "RECONCILIATION_DONE" ||
                !this.isAuthorized
            );
        },
        specificResult({ data, loading }: any) {
            if (!loading && data) {
                if (data.maxPrice && data.maxPrice.length && data.maxPrice[0].grossAmountSigned) {
                    this.maxDocumentAmount = data.maxPrice[0].grossAmountSigned;
                }
                if (data.minPrice && data.minPrice.length && data.minPrice[0].grossAmountSigned) {
                    this.minDocumentAmount = data.minPrice[0].grossAmountSigned;
                }
                // if (this.maxAmount !== undefined && this.maxAmount > this.maxDocumentAmount) {
                //     this.maxAmount = this.maxDocumentAmount
                // }
                // if (this.maxAmount !== undefined && this.maxAmount < this.minDocumentAmount) {
                //     this.maxAmount = this.maxDocumentAmount
                // }

                // if (this.minAmount !== undefined && this.minAmount < this.minDocumentAmount) {
                //     this.minAmount = this.minDocumentAmount
                // }

                // if (this.minAmount !== undefined && this.minAmount > this.maxDocumentAmount) {
                //     this.minAmount = this.minDocumentAmount
                // }
            }
        },
    })
    maxDocumentAmount = 0;

    minDocumentAmount = 0;

    get documents() {
        if (this.auditCheck) {
            return this.auditCheckDocumentItems;
        } else if (this.partitionTagId) {
            return this.partitionTagDocuments;
        }
        // console.log("get documents", this.dbDocuments);
        return this.dbDocuments;
    }

    async finishMounted() {
        this.allDocumentTypes = this.allTypes;
        this.onAccountingPeriodChanged(this.selectedAccountingPeriod, null);
        await this.$apollo.queries.dbDocuments.refetch();
    }

    unsubscribe() {
        this.removeListener();
    }

    @Apollo({
        query() {
            return this.query;
        },
        variables() {
            // this.loading = true;
            const where = getCommonDocumentWhere(
                this.selectedCompany.id,
                this.selectedAccountingClosing,
                this.filter,
                this.onlyAccounting,
            );
            return {
                companyId: this.selectedCompany.id,
                where,
                first:
                    this.filter.pagination.rowsPerPage > 0
                        ? this.filter.pagination.rowsPerPage
                        : 100,
                skip: this.filter.pagination.rowsPerPage * (this.filter.pagination.page - 1),
                orderBy: this.formatOrderBy(),
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return (
                !this.query ||
                this.auditCheck ||
                this.partitionTagId ||
                (this.filter?.type &&
                    (this.filter.type === "MAIL" ||
                        this.filter.type.startsWith("BANK_TRANSACTION"))) ||
                (this.filter?.status &&
                    (this.filter.status === "RECONCILIATION_MISSING" ||
                        this.filter.status === "RECONCILIATION_DONE")) ||
                !this.selectedCompany?.id ||
                !this.isAuthorized
            );
        },
        specificResult({ data, loading }: any) {
            // this.loading = loading;
            if (!loading && data) {
                this.firstRequestDone = true;
                // if (this.documents !== data.documents) {
                const documents = JSON.parse(JSON.stringify(data.documents));
                // const documents = data.documents
                for (const doc of documents) {
                    getChatStatus(this, doc, doc.chat);
                    this.computeReconciliationStatus(doc);
                }
                // this.dbDocuments.value = documents
                this.dbDocuments = documents;
                console.log("pagination", this.pagination);
                this.pagination.totalItems = data.documentAggregate.count;
                this.amountSum = data.documentAggregate.amountSum;
                this.addListener("document");
                // this.loading = false;
            }
        },
    })
    dbDocuments = [];

    onMessage(data) {
        console.log("on message documents");
        if (data) {
            if (data.action === "create") {
                // nothing to do
            }
            if (data.action === "update") {
                const index = this.dbDocuments.findIndex((aie) => aie.id === data.id);
                if (index !== -1) {
                    this.computeReconciliationStatus(data.payload);
                    this.dbDocuments.splice(index, 1, data.payload);
                }
            } else if (data.action === "delete") {
                const index = this.dbDocuments.findIndex((aie) => aie.id === data.id);
                if (index !== -1) {
                    this.dbDocuments.splice(index, 1);
                }
            }
        }
    }

    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.selectedCompany.id,
                auditCheck: this.auditCheck,
                // accountingPeriodId: this.$route.params.accountingPeriodId
                date_gte: this.beginDate || undefined,
                date_lte: this.endDate || undefined,
                isIgnored: !this.showIgnoredAuditChecks,
            };
        },
        debounce: 500,
        skip() {
            return (
                !this.auditCheck ||
                this.partitionTagId ||
                !this.selectedCompany ||
                !this.selectedCompany.id ||
                !this.isAuthorized
            );
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                this.unsubscribe();
                this.pagination.totalItems = 0;
                this.amountSum = 0;

                if (data && data.auditDocumentItems) {
                    // console.log(data.auditItems);
                    const documents = data.auditDocumentItems;
                    documents.sort((a, b) => {
                        if (a.date < b.date) return 1;
                        if (a.date > b.date) return -1;
                        if (a.grossAmountSigned < b.grossAmountSigned) return 1;
                        if (a.grossAmountSigned > b.grossAmountSigned) return -1;
                        return 0;
                    });

                    for (const doc of documents) {
                        getChatStatus(this, doc, doc.chat);
                        this.computeReconciliationStatus(doc);
                    }

                    this.auditCheckDocumentItems = documents;
                    this.pagination.totalItems = documents.length;
                    this.amountSum = 0;

                    // this. auditCheckBTItems = bts
                    // this.pagination.totalItems = this. auditCheckBTItems.length
                } else {
                    // this. auditCheckBTItems = [];
                }
            }
        },
    })
    auditCheckDocumentItems: Array<any> = [];

    @Apollo({
        query: UNTAGGED_DOCUMENTS,
        variables() {
            return {
                partitionTagId: this.partitionTagId,
                where: getCommonDocumentWhere(
                    this.selectedCompany.id,
                    this.selectedAccountingClosing,
                    this.filter,
                    this.onlyAccounting,
                ),
            };
        },
        debounce: 500,
        skip() {
            return (
                this.auditCheck ||
                !this.partitionTagId ||
                !this.selectedCompany ||
                !this.selectedCompany.id ||
                !this.isAuthorized
            );
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                this.unsubscribe();
                this.pagination.totalItems = 0;
                this.amountSum = 0;

                if (data?.untaggedDocuments?.documentIds) {
                    // console.log(data.auditItems);
                    // const documents = data.untaggedDocuments.documentIds

                    this.partitionTagDocumentIds = data.untaggedDocuments.documentIds;
                    this.pagination.totalItems = this.partitionTagDocumentIds.length;
                    this.amountSum = 0;
                } else {
                    this.partitionTagDocumentIds = [];
                    this.pagination.totalItems = 0;
                    this.amountSum = 0;
                }
            }
        },
    })
    partitionTagDocumentIds: Array<any> = [];

    get filteredPartitionTagDocumentIds() {
        const ids = [];
        if (this.partitionTagDocumentIds.length) {
            let index = this.filter.pagination.rowsPerPage * (this.filter.pagination.page - 1);
            const first =
                this.filter.pagination.rowsPerPage > 0 ? this.filter.pagination.rowsPerPage : 100;
            let end = index + first;
            end =
                end < this.partitionTagDocumentIds.length
                    ? end
                    : this.partitionTagDocumentIds.length;

            for (; index < end; index++) {
                ids.push(this.partitionTagDocumentIds[index]);
            }
        }
        return ids;
    }

    @Apollo({
        query: DOCUMENTS_ID_IN,
        variables() {
            return {
                companyId: this.selectedCompany.id,
                documentIds: this.filteredPartitionTagDocumentIds,
            };
        },
        skip() {
            return (
                this.auditCheck ||
                !this.partitionTagId ||
                !this.filteredPartitionTagDocumentIds.length ||
                !this.selectedCompany ||
                !this.isAuthorized
            );
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                this.unsubscribe();
                this.amountSum = 0;
                if (data && data.documents) {
                    const documents = data.documents;

                    for (const doc of documents) {
                        getChatStatus(this, doc, doc.chat);
                        this.computeReconciliationStatus(doc);
                    }

                    this.partitionTagDocuments = documents;
                    this.amountSum = 0;
                } else {
                    this.partitionTagDocuments = [];
                    this.amountSum = 0;
                }
            }
        },
    })
    partitionTagDocuments: Array<any> = [];

    beforeDestroy() {
        if (this.$apollo.queries && this.$apollo.queries.dbDocuments) {
            this.$apollo.queries.dbDocuments.stop();
        }
        this.removeListener();
    }

    grossAmountSignedAsValue(document) {
        if (document) {
            if (document.grossAmountSigned !== null) {
                return document.grossAmountSigned;
            }
            if (document.type === "PAY_SLIP") {
                if (
                    document.data &&
                    document.data.payslip.totalCost &&
                    document.data.payslip.totalCost
                ) {
                    return -document.data.payslip.totalCost;
                }
            }
        }
        return null;
    }

    grossAmountSigned(document) {
        return this.grossAmountSignedAsValue(document);
    }

    getDocumentTitle(item, truncateText: boolean = true) {
        return getDocumentTitle(item, truncateText);
    }

    dateFromNow(date: string) {
        return moment(date).fromNow();
    }

    formatDateMobile(date) {
        if (!date) return null;
        return moment(date).format("DD MMM");
    }

    formatRangeDate(rangeDate: any) {
        let formated = "";

        if (rangeDate.begin && rangeDate.end) {
            formated = `du ${moment(rangeDate.begin).format(rangeDate.format)} au ${moment(
                rangeDate.end,
            ).format(rangeDate.format)}`;
        } else if (rangeDate.begin && !rangeDate.end) {
            formated = `A partir du ${moment(rangeDate.begin).format(rangeDate.format)}`;
        } else if (!rangeDate.begin && rangeDate.end) {
            formated = `Jusqu'au ${moment(rangeDate.end).format(rangeDate.format)}`;
        } else {
            formated = "Filtrer par date";
        }
        return formated;
    }

    formatOrderBy(): string {
        const fieldName = this.pagination.sortBy[0] || "type";
        const direction = this.pagination.descending[0] ? "_DESC" : "_ASC";
        return fieldName + direction;
    }

    openDocument(document: Document, reconciliationIfPossible: boolean = false) {
        if (this.freeTagFocused) return;
        if (reconciliationIfPossible) {
            if (this.reconciliationIcon(document)) {
                this.$router.push({
                    name: "reconciliation/document",
                    params: {
                        companyId: this.selectedCompany.id,
                        documentId: document.id,
                    },
                });
                return;
            }
        }
        this.$router.push({
            name: "document",
            params: {
                companyId: this.selectedCompany.id,
                id: document.id,
            },
        });
    }

    //     save(filename, data, dataType) {
    //     var blob = new Blob([data], {type: dataType});
    //     if(window.navigator.msSaveOrOpenBlob) { // IE10+
    //         window.navigator.msSaveBlob(blob, filename);
    //     }
    //     else{ // Others
    //         var elem = window.document.createElement('a');
    //         elem.href = window.URL.createObjectURL(blob);
    //         elem.download = filename;
    //         document.body.appendChild(elem);
    //         elem.click();
    //         document.body.removeChild(elem);
    //     }
    // }

    menuLoading = false;

    async startDownloadFile() {
        this.menuLoading = true;
        try {
            await this.downloadFile(true);
            this.menuLoading = false;
        } catch {
            this.menuLoading = false;
        }
    }

    /**
     * method called for single or multiple downloads
     * Multiple calls for graphQL query
     */
    async downloadFile(original) {
        if (this.selectedDocumentIds.length === 1) {
            for (const docId of this.selectedDocumentIds) {
                const randNumber = Math.floor(Math.random() * 99);
                if (original) {
                    // await axios.get(`${env.VUE_APP_BACKEND}/document/download/${docId}/original`, {})
                    window.open(
                        `${env.VUE_APP_BACKEND}/document/download/${docId}/original?cache=${randNumber}`,
                        "_blank",
                    );
                } else {
                    // await axios.get(`${env.VUE_APP_BACKEND}/document/download/${docId}`, {})
                    window.open(
                        `${env.VUE_APP_BACKEND}/document/download/${docId}?cache=${randNumber}`,
                        "_blank",
                    );
                }
            }
        } else {
            try {
                const response = await axios.post(
                    `${env.VUE_APP_BACKEND}/document/downloadZip`,
                    {
                        data: {
                            documentIds: this.selectedDocumentIds,
                        },
                    },
                    {
                        responseType: "blob",
                    },
                );
                const blob = new Blob([response.data], { type: "application/zip" });
                fileDownload(blob, "bobbee-download-" + moment().format() + ".zip");
            } catch (error) {
                console.error("Error downloading documents:", error);
            }
        }
        this.selectedDocumentIds = [];
    }

    //
    // CHAT LIST
    //

    onIntersect(_, entries, observer) {
        if (entries[0].isIntersecting) {
            this.pagination.rowsPerPage += 10;
        }
    }

    onImportDone() {
        this.stripeDialog = false;
        this.refetchDocuments();
    }

    isSelected(id) {
        return this.selectedDocumentIds.findIndex((x) => x === id) !== -1;
    }

    addSelectedDocument(id) {
        if (this.isSelected(id)) {
            this.selectedDocumentIds = this.selectedDocumentIds.filter((x) => x !== id);
        } else {
            this.selectedDocumentIds.push(id);
        }
    }

    refresh() {
        if (this.$apollo.queries.dbDocuments) {
            this.$apollo.queries.dbDocuments.refetch();
        }
    }

    async deleteDocuments(lightDelete = true) {
        await this.$apollo.mutate({
            mutation: DELETE_DOCUMENTS,
            variables: {
                companyId: this.selectedCompany.id,
                documentIds: this.selectedDocumentIds,
                lightDelete,
            },
        });
        this.selectedDocumentIds = [];
        if (!lightDelete) {
            this.dialogDeletePermanentlySelectedDocument = false;
        } else {
            this.dialogDeleteSelectedDocument = false;
        }
        this.refresh();
    }

    async changeThirdPartyCompany() {
        if (!this.newThirdPartyCompany.id) {
            this.newThirdPartyCompany.id = await createCompany(
                this.$apollo,
                this.newThirdPartyCompany,
            );
        }
        await this.$apollo.mutate({
            mutation: UPDATE_THIRDPARTY_COMPANY_DOCUMENTS,
            variables: {
                documentIds: this.selectedDocumentIds,
                thirdPartyCompanyId: this.newThirdPartyCompany.id,
            },
        });
        this.dialogChangeThirdPartyCompanyDocument = false;
    }

    get disabledDownload() {
        if (this.selectedDocumentIds.length === 0) {
            return true;
        }
        // if (!this.selectedDocumentIds.length) {
        //     return true
        // }
        for (const docId of this.selectedDocumentIds) {
            const doc = this.documents.find((d) => d.id === docId);
            if (
                doc &&
                doc.type !== "SALES_INVOICE" &&
                doc.type !== "PURCHASE_INVOICE" &&
                doc.type !== "CURRENT_ACCOUNT" &&
                doc.type !== "OPERATOR_ACCOUNT" &&
                doc.type !== "MISCELLANEOUS" &&
                doc.type !== "UNKNOWN"
            ) {
                return true;
            }
        }
        return false;
    }

    containsValidatedReconciliation(doc) {
        const reconciliationStatus = doc.reconciliationStatus;

        if (reconciliationStatus) {
            if (reconciliationStatus.allStatus) {
                if (reconciliationStatus.allStatus.EDITION) {
                    return true;
                }
                if (reconciliationStatus.allStatus.RECONCILIATION_DONE) {
                    return true;
                }
                if (reconciliationStatus.allStatus.PENDING_VALIDATION) {
                    // return true
                }
                if (reconciliationStatus.allStatus.VALIDATED) {
                    return true;
                }
            } else if (reconciliationStatus.status) {
                if (reconciliationStatus.status === "EDITION") {
                    return true;
                }
                if (reconciliationStatus.status === "RECONCILIATION_DONE") {
                    return true;
                }
                if (reconciliationStatus.status === "PENDING_VALIDATION") {
                    // return true
                }
                if (reconciliationStatus.status === "VALIDATED") {
                    return true;
                }
            }
        }
        return false;
    }

    get displayDeletePermanentlyButton() {
        if (this.filter.status === "DELETED") {
            return true;
        }
        return false;
    }

    get disabledDeletePermanently() {
        if (!this.selectedDocumentIds.length) {
            return true;
        }
        for (const docId of this.selectedDocumentIds) {
            const doc = this.documents.find((d) => d.id === docId);
            if (doc.status !== "DELETED") {
                return true;
            }
        }
        return false;
    }

    get disabledDelete() {
        if (!this.selectedDocumentIds.length) return true;

        for (const docId of this.selectedDocumentIds) {
            const doc = this.documents.find((d) => d.id === docId);
            if (isDeletionDisabled(doc, this.isAccountingUser, this.$store)) {
                return true;
            }
        }
        return false;
    }

    onMultiTagguingApplied() {
        this.selectedDocumentIds = [];
        // this.documents = []
        // this.$apollo.queries.documents.refetch();
    }

    // formatSnackbarTags(tagsSelected) {
    //     let companies = uniqBy(this.documents.filter(x => this.selectedDocumentIds.includes(x.id)).map(x => x.thirdPartyCompany))
    //     let tagsSelectedId = tagsSelected.map(x => x.tagId)
    //     let tags = this.companyTags.filter(x => tagsSelectedId.includes(x.id))
    //     let snackbar = []
    //     debugger
    //     for (let tag of tags) {
    //         companies.forEach(comp => {
    //             snackbar.push({
    //                 tag: tag,
    //                 company: comp,
    //                 display: true
    //             })
    //         });
    //     }
    //     return snackbar
    // }

    // async createSuggestion(index, tagId, tCompanyId) {
    //     if (tagId && tCompanyId && this.selectedCompany.id) {
    //         await this.$apollo.mutate({
    //             mutation: CREATE_THIRDPARTYCOMPANY_TAG_RULE,
    //             variables: {
    //                 companyId: this.selectedCompany.id,
    //                 thirdPartyCompanyId: tCompanyId,
    //                 tagId: tagId
    //             }
    //         }).catch((err) => {
    //         });
    //     }
    //     this.snackbars[index].display = false
    // }

    setDocumentTags(list) {
        // debugger
        this.documentTags = list;
    }

    getAmountClass(document) {
        return this.grossAmountSignedAsValue(document) < 0 ? "redAmount" : "";
    }

    computeReconciliationStatus(doc) {
        const reconciliationStatus = {
            allStatus: {},
            toReconciliateAmountSigned: 0.0,
            notReconciliatedAmountSigned: 0.0,
            reconciliatedAmountSigned: 0.0,
        };
        for (let index = doc.accountingLines.length - 1; index >= 0; index--) {
            if (doc.accountingLines[index].type === "ORIGNAL") {
                doc.accountingLines.splice(index, 1);
            }
        }

        doc.accountingLineTags = [];

        for (const al of doc.accountingLines) {
            if (al.accountableAccount?.name && this.$store.state.accountableAccountTable) {
                const dbAA = this.$store.state.accountableAccountTable.accountableAccounts.find(
                    (aa) => aa.name === al.accountableAccount.name,
                );
                if (dbAA?.lettering) {
                    reconciliationStatus.toReconciliateAmountSigned += al.amountSigned;
                    if (al.reconciliation) {
                        reconciliationStatus.reconciliatedAmountSigned += al.amountSigned;
                        if (reconciliationStatus.allStatus[al.reconciliation.status]) {
                            reconciliationStatus.allStatus[al.reconciliation.status]++;
                        } else {
                            reconciliationStatus.allStatus[al.reconciliation.status] = 1;
                        }
                    } else {
                        reconciliationStatus.notReconciliatedAmountSigned += al.amountSigned;
                    }
                }
            }

            //
            //
            //
            if (al.tag && !doc.accountingLineTags.find((alt) => alt.id === al.tag.id)) {
                doc.accountingLineTags.push(al.tag);
            }
            if (al.tags) {
                for (const tag of al.tags) {
                    if (!doc.accountingLineTags.find((alt) => alt.id === tag.id)) {
                        doc.accountingLineTags.push(tag);
                    }
                }
            }
        }
        if (Math.abs(reconciliationStatus.notReconciliatedAmountSigned) < 1e-3) {
            reconciliationStatus.notReconciliatedAmountSigned = 0.0;
        }

        doc.reconciliationStatus = reconciliationStatus;
    }

    clearAllFilters() {
        this.search = "";
        this.minAmount = "";
        this.maxAmount = "";
        this.beginDate = "";
        this.endDate = "";
        this.documentType = "ALL";
        this.documentStatus = "ALL";
        this.declaredStatus = "ALL";
        this.auditCheck = "";
        this.partitionTagId = "";
        this.thirdPartyCompanyName = "";
    }
}
